import { ENV } from "../env/env";

export const api_routes = {
  /*
   * Auth Routes
   */
  auth: {
    login: "/user/auth/login",
    logout: "/user/logout",
  },
  /*
   * Apps Routes
   */
  apps: {
    getUserApps: `${ENV.APPLICATIONS_API_ENDPOINT}/applications`,
    getAppLogo: `${ENV.APPLICATIONS_API_ENDPOINT}/applications`,
  },
  /*
   * Profile Routes
   */
  profile: {
    findUser: "/user/find/",
    allUsers: "/user/allUsers",
    myProfile: "/user/myprofile",
    checkLogin: "/user/auth/check-login",
  },
  /*
   * Notification Routes
   */
  notification: {
    unread: "/notification/unread",
    readAll: "/notification/readAll",
    readOne: "/notification/readOne",
  },
  /*
   * Profile Routes
   */
  department: {
    list: "/user/department/list",
  },
  /*
   * Post Routes
   */
  post: {
    getAll: "/post/getallPost",
    common: "/post/common",
    add: "/post/addPost",
    hide: "/post/hide/",
    unhide: "/post/unhide/",
    pin: "/post/pin/",
    unpin: "/post/unpin/",
    getPrivate: "/post/getPrivatePosts",
    archive: "/post/archive",
    hidden: "/post/hidden",
    scheduled: "/post/scheduled",
    scheduledUpdate: (id: string) => `/post/scheduled/${id}`,
    scheduledPublish: (id: string) => `/post/scheduled/${id}/publish`,
    drafts: "/post/drafts",
    draftPollUpdate: (id: string) => `/post/drafts/${id}/poll`,
    draftPublish: (id: string) => `/post/drafts/${id}/publish`,
    delete: "/post/delete/",
    update: "/post/update/",
    feature: "/post/feature/",
    view: (postTypeId: string) => `/post/${postTypeId}/views`,
    stats: (postTypeId: string) => `/post/${postTypeId}/stats`,
    pollAdd: "/post/poll",
    pollVote: (pollId: string) => `/post/poll/${pollId}/vote`,
    getPoll: (pollId: string) => `/post/poll/${pollId}`,
    close: (pollId: string) => `/post/poll/${pollId}/close`,
    reopen: (pollId: string) => `/post/poll/${pollId}/reopen`,
  },
  /*
   * Like Routes
   */
  like: {
    add: "/post/addLikes",
    get: "/post/getLikes/",
    toggle: "/post/toggleLike/",
    delete: "/post/deleteLikes/",
  },
  /*
   * Comment Routes
   */
  comment: {
    all: "/post/allComment",
    add: "/post/addComment",
    delete: "/post/deleteComment/",
    update: "/post/updateComment/",
    toggleLike: "/post/comment/togglelike/",
    getLikes: "/post/comment/getlikes/"
  },
  /*
   * Answer Routes (Q&A posts)
   */
  answer: {
    all: "/post/allAnswer",
    add: "/post/addAnswer",
    accept: "/post/answer/accept/", // {postTypeId}/{answerId}
    update: "/post/updateAnswer/", // {postTypeId}/{answerId}
    delete: "/post/deleteAnswer/", // {postTypeId}/{answerId}
    toggleLike: "/post/answer/toggleLike/", // {answerId}
    getTotalLikes: "/post/answer/getTotalLikes/", // {answerId}
  },
  /*
   * Challenge Routes
   */
  challenge: {
    all: "/challenge",
    add: "/challenge",
    delete: "/challenge/",
    update: "/challenge/",
    assignment: "/challenge/assignment",
    userActionAssignment: "/challenge/user-action-assignment",
    assignmentCompleted: "/challenge/assignment/complete",
    assignmentValidate: "/challenge/assignment/validate",
  },
  /*
   * Reward Routes
   */
  reward: {
    create: "/reward",
    get: "/reward",
    delete: "/reward",
    update: "/reward/",
    generateReport: "/reward/report",
    generateTaxReport: "/reward/tax-report",
    category: {
      create: "/reward/category",
      get: "/reward/category",
      delete: "/reward/category",
    },
    sub_category: {
      create: "/reward/sub-category",
      get: "/reward/sub-category",
      delete: "/reward/sub-category",
    },
    purchase: "/reward/purchases",
    taxBenefits: "/reward/tax-benefits",
    vendor: {
      list: "/vendor",
      dropDownlist: "/vendor?includeAll=true",
    },
  },

  /*
   * Reward Routes
   */
  awards: {
    issue: "/award/issue",
    get: "/award/awardpage/all",
  },

  /*
   * Leaderboard Routes
   */
  leaderboard: {
    list: "/user/points/leaderboard",
    department: "/user/department/points/leaderboard",
  },

  /*
   * Recognition Routes
   */
  recognition: {
    add: "/recognition/add",
    update: "/recognition/update/",
  },

  reminders: {
    get: "/reminders",
    upsert: "/reminders",
  },

  /*
   * User Routes
   */
  user: {
    profile: "/user/myprofile",
    progress: "/user/userProgress",
    awards: "/award/myProfileAwards",
    skills: "/user/skillsRecognized",
    points: "/user/points",
    update: "/user/update",
    recognitionPreferences: "/user/recognition-preferences",
  },

  /*
   * Admin Users Routes
   */

  admin: {
    adminAllUsers: "/admin/allUsers",
    organisationList: "/admin/organisationList",
    userCheckIn: "/admin/userCheckIn",
    deleteUser: "/admin/deleteUser",
    editUser: "/admin/userProfileEdit",
    impersonate: "/admin/impersonate",
    pointSummary: "/admin/getTransaction",
    checkEmailExists: "/admin/check-user-profile-by-email",
    syncUserFromPortal: "/admin/sync-user"
  },
  teams: {
    list: "/teams",
    myTeams: "/teams/myteams",
  },
  /*
   * User Sync Routes
   */
  userSync: {
    status: "/user-sync/status",
    progress: "/user-sync/progress",
    current: "/user-sync/current",
    details: "/user-sync/details",
    batches: "/user-sync/batches",
    history: "/user-sync/history"
  },

  orgNavSettings: {
    getByOrg: (organizationId: string) =>
      `/org-nav-settings/organization/${organizationId}`,
    upsertByOrg: (organizationId: string) =>
      `/org-nav-settings/organization/${organizationId}`,
  },

  /*
   * Skill Routes
   */

  skill: {
    addNewSkill: "/skill/add",
    getAllSkills: "/skill/getAll",
    updateSkill: "/skill/update",
    deleteSkill: "/skill/delete",
  },

  /*
   * Event Routes
   */

  event: {
    addNewEvent: "/event/add",
    getAllEvents: "/event/all",
    updateEvent: "/event/update",
    deleteEvent: "/event/delete",
    rsvp: (eventId: string) => `/event/${eventId}/rsvp`,
    rsvps: (eventId: string) => `/event/${eventId}/rsvps`,
    attendance: (eventId: string) => `/event/${eventId}/attendance`,
    markAttendance: (eventId: string) => `/event/${eventId}/attendance/mark`,
  },

  /*
   * Vendor Routes
   */

  vendor: {
    addNewVendor: "/vendor",
    getAllVendors: "/vendor",
    updateVendor: "/vendor",
    deleteVendor: "/vendor",
    updateVendorPassword: (vendorId: string) => `/admin/vendor/${vendorId}/password`,
    // Vendor Group CRUD
    getGroups: "/vendor/groups",
    createGroup: "/vendor/groups",
    updateGroup: (groupId: string) => `/vendor/groups/${groupId}`,
    deleteGroup: (groupId: string) => `/vendor/groups/${groupId}`,
    // Vendor Group Member Management
    getGroupMembers: (groupId: string) => `/vendor/groups/${groupId}/members`,
    addGroupMembers: (groupId: string) => `/vendor/groups/${groupId}/members`,
    removeGroupMember: (groupId: string, vendorId: string) => `/vendor/groups/${groupId}/members/${vendorId}`,
    dropDownlist: "/vendor?includeAll=true",
  },

  /*
   * SUPER_ADMIN Route
   */

  super_admin: {
    addPoints: "/admin/addPoint",
    deductPoints: "/admin/deductPoint",
    getUserPoints: "/admin/getUserPoint",
  },

  survey: {
    getAllSurveys: "/survey/all",
    addSurvey: "/survey/create",
    updateSurvey: "/survey/update",
    deleteSurvey: "/survey/delete/",
    getSurvey: "/survey/",
    assignSurvey: "/survey/assign",
    getAllAssignedSurvey: "/survey/my-assignments/list",
    getAssignedSurveyInfo: "/survey/assigned/",
    submitSurvey: "/survey/response",
    surveyMetrics: "/survey/metrics/detailed/",
    surveyMetricsInfo: "/survey/metrics/filtered/",
    surveyExport: "/survey/metrics/export/",
    metricsResponsesExport: (surveyId: string) => `/survey/metrics/responses/${surveyId}/export`,
    metricsResponsesTable: (surveyId: string) => `/survey/metrics/responses/${surveyId}/table`,
    metricsResponsesAnalytics: (surveyId: string) => `/survey/metrics/responses/${surveyId}/analytics`,
  },

  distributorWallet: {
    getAllTransactions: "/admin/getDistributorTransaction/",
    assignPoints: "/admin/assign-point-balance",
    getDistributorPoints: "/admin/getDistributorPoint/",
  }
};
